import React, { useState } from "react";
import { config } from "../config/config";
import UsuarioForm from "../components/UsuarioForm";
import UsuarioList from "../components/UsuarioList";
import showAlert from '../components/Alert';
import showConfirm from "../components/ConfirmAlert";

const Usuarios = () => {
    const [editingUser, setEditingUser] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(false); // Estado para gestionar la recarga
    const [resetForm, setResetForm] = useState(false);

    const reloadUserList = () => {
        setReloadTrigger(!reloadTrigger); // Cambiar el valor para activar la recarga
    };

    const handleCreateOrUpdate = (usuario) => {
        const url = editingUser
            ? `${config.apiUrl}/usuarios/${editingUser.usuario_id}`
            : `${config.apiUrl}/usuarios`;
        const method = editingUser ? "PUT" : "POST";

        fetch(url, {
            method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(usuario),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error al guardar la información');
                }
                return response.json();
            })
            .then(() => {
                showAlert(editingUser, "Usuario");
                setEditingUser(null);
                setResetForm(true);
                reloadUserList(); // Recargar la lista después de guardar
            })
            .catch(console.error);
    };

    const handleDelete = async (id) => {
        const isConfirmed = await showConfirm();
        if (isConfirmed) {
            fetch(`${config.apiUrl}/usuarios/${id}`, { method: "DELETE" })
                .then(() => {
                    console.log("Usuario eliminado");
                    reloadUserList(); // Recargar la lista después de eliminar
                })
                .catch(console.error);
        }
    };

    return (
        <div>
            <UsuarioForm
                onSubmit={handleCreateOrUpdate}
                initialData={editingUser}
                resetForm={resetForm}
            />
            <UsuarioList
                onEdit={(user) => setEditingUser(user)}
                onDelete={handleDelete}
                reloadTrigger={reloadTrigger} // Pasamos reloadTrigger a UsuarioList
            />
        </div>
    );
};

export default Usuarios;
